import styled from "styled-components";

export const ListKnowledgeArea = styled.ul`
  list-style: none;
`;

export const TitleSection = styled.h4`
  margin-top: 1rem;
`;
